/*
 * MCRO001-F0050 / T-MCRO-050 — the `conflict` kind renderer.
 * A merge overlap: ours | theirs | both | hand-edit, resolved via the shared ResolvePicker.
 */

import React from 'react';
import ResolvePicker from './ResolvePicker';

export default function ConflictPicker(props) {
  return <ResolvePicker {...props} />;
}
